import { Popover, MenuList, MenuItem, ListItemText, Divider, Menu } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { useState } from 'react';
import { ChevronRight } from '@sweep-io/sweep-design/dist/icons';
import { useFeatureToggle } from '../../../../../feature-flags/useFeatureToggle';

export type SfFunnelMenuAction = 'deployToExisting' | 'deployToAnother' | 'remove' | 'delete';

interface SfFunnelMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onClick: (action: SfFunnelMenuAction, envId?: string) => void;
  otherEnvironments?: Array<{ id: string; name: string }>;
  disabled?: boolean;
}

export const SfFunnelMenu = ({
  anchorEl,
  onClose,
  onClick,
  otherEnvironments = [],
  disabled = false,
}: SfFunnelMenuProps) => {
  const { deployFromFunnelLabel } = useFeatureToggle();
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState<HTMLElement | null>(null);
  const isSubMenuOpen = Boolean(subMenuAnchorEl);

  const handleSubMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setSubMenuAnchorEl(event.currentTarget);
  };

  const handleSubMenuClose = () => {
    setSubMenuAnchorEl(null);
  };

  const handleSubMenuItemClick = (envId: string) => {
    onClick('deployToAnother', envId);
    handleSubMenuClose();
  };

  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: -7,
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: -8,
      }}
    >
      <MenuList sx={{ minWidth: '29px' }}>
        <MenuItem onClick={() => onClick('remove')} disabled={disabled}>
          <ListItemText>Remove from Canvas</ListItemText>
        </MenuItem>
        {!deployFromFunnelLabel && <Divider />}
        <MenuItem onClick={() => onClick('delete')} disabled={disabled}>
          <ListItemText sx={{ color: colors.blush[600] }}>Delete funnel</ListItemText>
        </MenuItem>
        {deployFromFunnelLabel && (
          <>
            <Divider />
            <MenuItem onClick={() => onClick('deployToExisting')} disabled={disabled}>
              <ListItemText>Deploy to existing Environment</ListItemText>
            </MenuItem>
            {otherEnvironments.length > 0 && (
              <>
                <MenuItem onClick={handleSubMenuClick} disabled={disabled}>
                  <ListItemText>Deploy to another Environment</ListItemText>
                  <ChevronRight size="medium" />
                </MenuItem>
                <Menu
                  anchorEl={subMenuAnchorEl}
                  open={isSubMenuOpen}
                  onClose={handleSubMenuClose}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  {otherEnvironments.map((env) => (
                    <MenuItem key={env.id} onClick={() => handleSubMenuItemClick(env.id)}>
                      <ListItemText>{env.name}</ListItemText>
                    </MenuItem>
                  ))}
                </Menu>
              </>
            )}
          </>
        )}
      </MenuList>
    </Popover>
  );
};
